import {
    ADD_NOTIFICATION_TYPE,
    ADD_REMOVAL_TYPE,
    ADD_COURSE_CODE,
    ADD_STUDENT,
    REMOVE_STUDENT,
    CLEAR_FORM_DATA,
    ADD_DECLARATION,
    CLEAR_SPECIFIC_FORM_DATA,
    LOAD_FORM_DATA
} from '../../../Actions/FormDataActions/MPL/AddMPLFormData';

const initialState = {
    notificationType: {
        value: "",
        label: ""
    },
    removalOfExclusion: null,
    removalType: null,
    courseCode: "",
    courseOutcome: "",
    status: {
        value: "Passed"
    },
    courseDescription: "",
    students: {},
    declaration: ''
};

export default function formReducer(state = initialState, action) {

    switch (action.type) {
        case ADD_NOTIFICATION_TYPE: {
            if (action.payload.value === 'notificationTrainingOutcome') {
                return {
                    ...state,
                    notificationType: action.payload,
                    removalType: null,
                    removalOfExclusion: null
                };
            }

            return {
                ...state,
                notificationType: action.payload,
            };
        }
            
        case ADD_REMOVAL_TYPE: {
            if (action.payload.value === 'category') {
                return {
                    ...state,
                    removalType: action.payload,
                    courseCode: "",
                    courseDescription: "",
                    courseOutcome: "",
                };
            }

            return {
                ...state,
                removalType: action.payload,
            };
        }

        case ADD_COURSE_CODE:
            return {
                ...state,
                courseCode: action.payload.courseCode,
                courseDescription: action.payload.courseDescription,
                courseOutcome: action.payload.courseOutcome
            };

        case ADD_STUDENT:
            return {
                ...state, 
                students: {
                    ...state.students,
                    [action.payload.studentArn]: action.payload
                }
            }

        case REMOVE_STUDENT: {
            let updatedStudents = state.students
            delete updatedStudents[action.payload]

            return {
                ...state, 
                students: updatedStudents
            }
        }

        case CLEAR_FORM_DATA: 
            return {
                ...state,
                notificationType: {
                    value: "",
                    label: ""
                },
                removalOfExclusion: null,
                removalType: null,
                courseCode: "",
                courseDescription: "",
                courseOutcome: "",
                students: {},
                declaration: ''
            }

        case CLEAR_SPECIFIC_FORM_DATA:
            var currentState = {...state};
            action.payload.map( item => {
                if (typeof currentState[item] === "string") {
                    currentState[item] = "";
                } else if (typeof currentState[item] === "object") {
                    currentState[item] = null;
                } else if (typeof currentState[item] === "boolean") {
                    currentState[item] = false;
                } else {
                    currentState[item] = null;
                }
            })
            return {
                ...currentState
            }

        case ADD_DECLARATION:
            return {
                ...state, 
                declaration: action.payload
            }

        case LOAD_FORM_DATA:
            return {
                ...action.payload
            }

        default:
            return state;
    }
}
